var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmexcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_67579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V14C0.5 15.1046 1.39543 16 2.5 16H22.5C23.6046 16 24.5 15.1046 24.5 14V2C24.5 0.89543 23.6046 0 22.5 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2656 13.3928V7.69141L24.4132 7.70051V9.27541L23.2403 10.5288L24.4132 11.7937V13.402H22.5405L21.5454 12.3038L20.5572 13.4061L14.2656 13.3928Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9414 12.7692V8.32031H18.7137V9.3452H16.1628V10.0409H18.6529V11.0487H16.1628V11.732H18.7137V12.7692H14.9414Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6954 12.7691L20.7827 10.5421L18.6953 8.32031H20.311L21.5865 9.73035L22.8656 8.32031H24.4117V8.35532L22.3689 10.5421L24.4117 12.706V12.7691H22.85L21.5519 11.3449L20.2671 12.7691H18.6954Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7388 2.63281H17.1849L18.044 4.58366V2.63281H21.0639L21.5846 4.09438L22.1071 2.63281H24.4131V8.3342H12.2266L14.7388 2.63281Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2006 3.25L13.2266 7.69517H14.5805L14.9529 6.80501H16.9708L17.343 7.69517H18.7306L16.7648 3.25H15.2006ZM15.3702 5.80744L15.9622 4.39236L16.5538 5.80744H15.3702Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7109 7.69508V3.25L20.6141 3.25654L21.5933 5.98927L22.579 3.25H24.4106V7.69508L23.232 7.70551V4.65217L22.1194 7.69508H21.0436L19.9079 4.64174V7.69508H18.7109Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_67579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexcard);
export default __webpack_public_path__ + "static/media/amexcard.3c8b828aa1be4dadb826dd1852eb781f.svg";
export { ForwardRef as ReactComponent };